import React from 'react'
import TagManager from 'react-gtm-module'

export default function useGoogleTagManagers() {
    React.useEffect(() => {
        TagManager.initialize({
            gtmId: window._env_.GoogleTagManagersKey
        });
    }, [])
}